import React, { useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

function Coupon() {
  const [coupon, setCoupon] = useState({
    name: "",
    type: "percentage",
    discount: "",
    from: new Date(),
    expiry: new Date(),
    usageLimit: "",
    status: "active",
  });

  const [coupons, setCoupons] = useState([
    {
      id: 1,
      name: "SUMMER20",
      type: "Percentage",
      discount: "20%",
      from: "2025-01-01",
      expiry: "2025-12-31",
      usageLimit: 100,
      status: "Active",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCoupon({ ...coupon, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setCoupon({ ...coupon, [name]: date[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newCoupon = {
      ...coupon,
      id: coupons.length + 1,
      from: coupon.from.toISOString().split("T")[0],
      expiry: coupon.expiry.toISOString().split("T")[0],
      type: coupon.type === "percentage" ? "Percentage" : "Fixed Amount",
      status: coupon.status === "active" ? "Active" : "Inactive",
    };
    setCoupons([...coupons, newCoupon]);

    setCoupon({
      name: "",
      type: "percentage",
      discount: "",
      from: new Date(),
      expiry: new Date(),
      usageLimit: "",
      status: "active",
    });
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Coupons</div>
          </div>

          {/* Coupon Form */}
          <div className="col-12 mb-4">
            <div className="card">
              <div className="card-header">Create New Coupon</div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Coupon Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name" placeholder="Enter Coupon Name"
                        value={coupon.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Type</label>
                      <select
                        className="form-control"
                        name="type" 
                        value={coupon.type}
                        onChange={handleChange}
                      >
                        <option value="percentage">Percentage</option>
                        <option value="fixed">Fixed Amount</option>
                      </select>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Discount</label>
                      <input
                        type="text"
                        className="form-control"
                        name="discount" placeholder="Enter Discount"
                        value={coupon.discount}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>From Date</label>
                      <Flatpickr
                        value={coupon.from}
                        onChange={(date) => handleDateChange("from", date)}
                        options={{ dateFormat: "Y-m-d" }}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Expiry Date</label>
                      <Flatpickr
                        value={coupon.expiry}
                        onChange={(date) => handleDateChange("expiry", date)}
                        options={{ dateFormat: "Y-m-d" }}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Usage Limit</label>
                      <input
                        type="number"
                        className="form-control"
                        name="usageLimit" placeholder="Enter Limit"
                        value={coupon.usageLimit}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={coupon.status}
                        onChange={handleChange}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="col-12 mt-1 text-end">
                      <button type="submit" className="btn btn-primary">
                        Create Coupon
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Coupons Table */}
          <div className="col-12">
            <div className="card">
              <div className="card-header">All Coupons</div>
              <div className="card-body table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Discount</th>
                      <th>From</th>
                      <th>Expiry</th>
                      <th>Usage Limit</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {coupons.map((c) => (
                      <tr key={c.id}>
                        <td>{c.id}</td>
                        <td>{c.name}</td>
                        <td>{c.type}</td>
                        <td>{c.discount}</td>
                        <td>{c.from}</td>
                        <td>{c.expiry}</td>
                        <td>{c.usageLimit}</td>
                        <td>
                          <span
                            className={`badge ${
                              c.status === "Active" ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {c.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Coupon;
